"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var Select_1 = __importDefault(require("@mui/material/Select"));
var svgs_1 = require("../../../assets/svgs");
var TextDropdown = function (_a) {
    var _b = _a.options, options = _b === void 0 ? [] : _b, _c = _a.defaultValue, defaultValue = _c === void 0 ? { label: '', value: '' } : _c, onChange = _a.onChange;
    var _d = (0, react_1.useState)(defaultValue.value), selectedOption = _d[0], setSelectedOption = _d[1];
    return ((0, jsx_runtime_1.jsx)(Select_1.default, __assign({ variant: "standard", labelId: "text-dropdown", value: selectedOption, IconComponent: svgs_1.ChevronDownCircle, onChange: function (_a) {
            var option = _a.target;
            setSelectedOption(option.value);
            onChange && onChange(option);
        }, MenuProps: {
            sx: {
                '& .MuiPopover-paper': {
                    boxShadow: '0px 12px 50px rgba(80, 41, 239, 0.08)',
                    borderRadius: '8px !important',
                },
                '& .MuiMenuItem-root:hover': {
                    background: '#fff',
                    color: 'primary.main',
                },
                '& .MuiMenuItem-root.Mui-selected': {
                    background: '#fff !important',
                    color: 'primary.main',
                },
                '& .MuiMenuItem-root.Mui-selected:hover': {
                    background: '#fff',
                    color: 'primary.main',
                },
                '& .MuiMenuItem-root.Mui-selected:active': {
                    background: '#fff',
                    color: 'primary.main',
                },
            },
        }, sx: {
            color: 'primary.400',
            textTransform: 'capitalize',
            '&::before': {
                borderBottom: 0,
            },
            '&:hover::before': {
                borderBottom: 0,
            },
            '&:hover:not(.Mui-disabled):before': {
                borderBottom: 0,
            },
            '&::after': {
                borderBottom: 0,
            },
            '&:hover::after': {
                borderBottom: 0,
            },
            '& .MuiSelect-select:focus': {
                background: 'none',
            },
            '& .MuiSelect-select.MuiInputBase-input.MuiInput-input': {
                paddingRight: '32px',
            },
            '& .MuiSelect-icon': {
                top: 'auto',
            },
        } }, { children: options.map(function (option) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: option.value, sx: {
                color: 'common.100',
                textTransform: 'capitalize',
            } }, { children: option.label }), "".concat(option.value, ".").concat(option.label))); }) })));
};
exports.default = TextDropdown;
